/**
 * Aarshaveda Theme - Native LocalStorage Wishlist Engine
 */

const WISHLIST_KEY = 'aarshaveda_wishlist';

const Wishlist = {
  getItems: function() {
    const raw = localStorage.getItem(WISHLIST_KEY);
    return raw ? JSON.parse(raw) : [];
  },

  setItem: function(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    this.dispatchEvent(items);
  },

  toggleItem: function(handle) {
    let items = this.getItems();
    if (items.includes(handle)) {
      items = items.filter(i => i !== handle);
    } else {
      items.push(handle);
    }
    this.setItem(items);
    return items.includes(handle);
  },

  dispatchEvent: function(items) {
    const event = new CustomEvent('av:wishlist:updated', {
      detail: { items: items, count: items.length }
    });
    document.dispatchEvent(event);
  },

  initButtons: function() {
    const buttons = document.querySelectorAll('[data-wishlist-toggle]');
    const items = this.getItems();

    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-wishlist-toggle');
      
      // Initial state
      if (items.includes(handle)) {
        btn.classList.add('av-wishlist-active');
        const svg = btn.querySelector('svg');
        if (svg) {
          svg.style.fill = 'currentColor'; // solid color for active
        }
      }

      // We clone the button or remove existing listeners to prevent duplicates
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const h = newBtn.getAttribute('data-wishlist-toggle');
        const isActive = this.toggleItem(h);
        
        // Find all buttons matching this handle (e.g. grid vs quickview)
        const matchedButtons = document.querySelectorAll(`[data-wishlist-toggle="${h}"]`);
        matchedButtons.forEach(b => {
          if (isActive) {
            b.classList.add('av-wishlist-active');
            const icon = b.querySelector('svg');
            if (icon) icon.style.fill = 'currentColor';
          } else {
            b.classList.remove('av-wishlist-active');
            const icon = b.querySelector('svg');
            if (icon) icon.style.fill = 'none';
          }
        });
      });
    });
  },

  initBadge: function() {
    const badges = document.querySelectorAll('[data-wishlist-count]');
    const updateBadges = (count) => {
      badges.forEach(b => {
        if (count > 0) {
          b.textContent = count;
          b.style.display = 'flex';
        } else {
          b.style.display = 'none';
        }
      });
    };

    // Set initial
    updateBadges(this.getItems().length);

    // Listen to changes
    document.addEventListener('av:wishlist:updated', (e) => {
      updateBadges(e.detail.count);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.initButtons();
  Wishlist.initBadge();
});

// For AJAX injected products, expose global function
window.AarshavedaWishlistInit = () => {
  Wishlist.initButtons();
};
